import React from 'react'
import BusinessEntities from './BusinessEntities/BusinessEntities'
import MetaData from './MetaData/MetaData'
import TokenDialog from './TokenDialog/TokenDialog'
import useRefreshToken from './useRefreshToken'

const Details = (props) => {
    const refreshToken = useRefreshToken()

    return (
        <>
            <div className="col-lg-8">
                <div className="card mndesc">
                    <BusinessEntities
                        businessEntitiesSource={props.businessEntitiesSource}
                        businessEntitiesTarget={props.businessEntitiesTarget}
                        sourceName={props.sourceName}
                        targetName={props.targetName}
                        sourceShortName={props.sourceShortName}
                        targetShortName={props.targetShortName}
                        instancesId={props.instancesId}
                        sourceId={props.sourceId}
                        targetId={props.targetId}
                    />
                </div>
            </div>

            <div className="col-lg-4">
                <div className="card mndesc">
                    <MetaData
                        sourceName={props.sourceName}
                        sourceVersion={props.sourceVersion}
                        targetName={props.targetName}
                        targetVersion={props.targetVersion}
                        featureName={props.featureName}
                        sourceType={props.sourceType}
                        targetType={props.targetType}
                        targetShortName={props.targetShortName}
                        connectorId={props.connectorId}
                        instancesId={props.instancesId}
                        onViewToken={refreshToken.open}
                    />
                </div>
            </div>

            <TokenDialog
                isOpen={refreshToken.isOpen}
                token={refreshToken.token}
                hasToken={refreshToken.hasToken}
                isLoading={refreshToken.isLoading}
                isGenerating={refreshToken.isGenerating}
                isDeleting={refreshToken.isDeleting}
                isConfirmingDelete={refreshToken.isConfirmingDelete}
                onClose={refreshToken.close}
                onCopy={refreshToken.copy}
                onRequestDelete={refreshToken.requestDelete}
                onCancelDelete={refreshToken.cancelDelete}
                onConfirmDelete={refreshToken.confirmDelete}
                onGenerate={refreshToken.generate}
            />
        </>
    )
}

export default Details
